import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import DatePicker from "react-datepicker";
import TooltipComponent from '../../tooltip/TooltipComponent';

import "react-datepicker/dist/react-datepicker.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import "./DatePicker.scss"
import "./DateRange.scss";

// We need to implement a lot of feature related to the datatime.

const DatePickerComponent = ({
    selected,
    onChange,
    placeholder,
    onBlur,
    isDisable,
    datePickerConfig,
    inputInfoConfig,
}) => {


    const [startRange, setStartRange] = useState(null);
    const [endRange, setEndRange] = useState(null);

    const configMapping = {
        format: "dateFormat",
        timeFormat: "timeFormat",
        timeIntervals: "timeIntervals",
        isMonthPicker: "showMonthYearPicker",
        displayInline: "inline",
        minDate: "minDate",
        maxDate: "maxDate",
        startDate: "openToDate",
        displayWeekNumber: "showWeekNumbers",
        selectWeekDates: "showWeekPicker",
        enableTodayBtn: "todayButton",
        highlightDates: "highlightDates",
        locale: "locale",
        calPropUpPosition: "popperPlacement",
        allowClear: "isClearable",
        showIcon: "showIcon",
        icon: "icon",
        holidays: "holidays",
        displayYearddl: "showYearDropdown",
        noOfYearinDdl: "yeardisplayinDropDown",
        noOfYear: "yearItemNumber",
        enableDdlScroll: "scrollableYearDropdown",
        inline: "inline",
        monthsToShow: "monthsShown",

        // Css Related Configuration
        className: "className", // class name for calender
        timeClassName: "timeClassName", // class name for Time Input
        calendarClassName: "calendarClassName", // class name for Menu
        dayClassName: "dayClassName", // class name for days

        // Excluding
        excludeDates: "excludeDates",
        excludeDateIntervals: "excludeDateIntervals", // Exclude date intervals

        // Range configuration
        isSingleRangePicker: "selectsRange",

        // Time Input configurations
        displayTimeInput: "showTimeInput",
        displayTimeSelect: "showTimeSelect",
        displayTimeSelectOnly: "showTimeSelectOnly",
        filteredTime: "filterTime",
        filteredDate: "filterDate",


        // Month configuration
        displayMonthPicker: "showMonthYearPicker",
        displayFullMonthName: "showFullMonthYearPicker",
        displayDoubleColumnMonthPicker: "showTwoColumnMonthYearPicker",
        displayFourColumnMonthPicker: "showFourColumnMonthYearPicker",
        displayMonthDropdown: "showMonthDropdown",
        displayShortMonthDropdown: "useShortMonthInDropdown",
        displayMonthYearDropdown: "showMonthYearDropdown",
        multiMonthsCount: "monthsShown",
        displayPreviousMonth: "showPreviousMonths",

        // Year configurations
        displayYearPicker: "showYearPicker",

        // Quarter configuration
        displayQuarterPicker: "showQuarterYearPicker",
        renderCustomHeader: "renderCustomHeader",
        renderDayContents: "renderDayContents",
        renderMonthContent: "renderMonthContent",
        renderQuarterContent: "renderQuarterContent",
        renderYearContent: "renderYearContent"
    };

    const dynamicAttributes = Object.entries(configMapping).reduce((acc, [configKey, propKey]) => {
        if (datePickerConfig?.[configKey] !== undefined) {
            acc[propKey] = datePickerConfig[configKey];
        }
        return acc;
    }, {});


    // const handleDateChange = useCallback((newValue) => {

    //     if (datePickerConfig?.singleInputRangePicker) {
    //         const [startDate, endDate] = newValue;
    //         setStartRange(startDate);
    //         setEndRange(endDate);
    //     }
    //     if (onChange) {
    //         onChange(newValue);
    //     }
    // }, [onChange]);

    // const handleDateChange = useCallback((newValue) => {
    //     if (datePickerConfig?.singleInputRangePicker) {
    //         const [startDate, endDate] = newValue;
    //         if (!startRange || (startRange && endRange)) {
    //             setStartRange(startDate);
    //             setEndRange(endDate ?? null);
    //             if (onChange) onChange([startDate, endDate]); // ✅ Pass correct range update
    //         }
    //         else {
    //             setEndRange(endDate);
    //             if (onChange) onChange([startRange, endDate]); // ✅ Update endDate properly
    //         }
    //     } else {
    //         setStartRange(newValue);
    //         setEndRange(null);
    //         if (onChange) {
    //             onChange(newValue);
    //         }
    //     }
    // },
    //     [onChange, datePickerConfig]
    // );

    const handleDateChange = useCallback((newValue) => {
        if (datePickerConfig?.singleInputRangePicker) {
            const [startDate, endDate] = newValue;
            setStartRange(startDate ?? null);
            setEndRange(endDate ?? null);
            if (onChange) onChange(newValue);
        } else {
            setStartRange(newValue);
            setEndRange(null);
            if (onChange) onChange(newValue);
        }
    }, [onChange, datePickerConfig]);

    // useEffect(() => {
    //     if (datePickerConfig?.singleInputRangePicker && selected === null) {
    //         setStartRange(null);
    //         setEndRange(null);
    //     }
    // }, [selected, datePickerConfig]);

    useEffect(() => {
        if (datePickerConfig?.singleInputRangePicker) {
            if (!selected || (Array.isArray(selected) && selected.every(date => !date))) {
                setStartRange(null);
                setEndRange(null);
            } else if (Array.isArray(selected)) {
                const [startDate, endDate] = selected;
                setStartRange(startDate ?? null);
                setEndRange(endDate ?? null);
            }
        } else if (!selected) {
            setStartRange(null);
        } else {
            setStartRange(selected);
        }

    }, [selected, datePickerConfig]);

    return (
        <div className="date-picker multiple-date">
            <DatePicker
                placeholderText={placeholder}
                selected={!datePickerConfig?.singleInputRangePicker ? selected : startRange}
                onChange={handleDateChange}
                onBlur={onBlur}
                autoComplete="off"
                disabled={isDisable}
                selectsRange={datePickerConfig?.singleInputRangePicker} // ✅ Enable range selection
                startDate={startRange}
                endDate={endRange}

                {...dynamicAttributes}  // Dynamically added attributes
            />

            {inputInfoConfig?.isInfoIcon && (
                <div>
                    {inputInfoConfig?.isInfoIcon && (
                        <TooltipComponent
                            iconName={inputInfoConfig?.iconName}
                            message={inputInfoConfig?.message}
                        />
                    )}
                </div>
            )}
        </div>
    );
};


export default DatePickerComponent;

DatePickerComponent.propTypes = {
    // selected: PropTypes.instanceOf(Date).isRequired,
    selected: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.arrayOf(PropTypes.instanceOf(Date)),
    ]).isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    onBlur: PropTypes.func,
    isDisable: PropTypes.bool,
    datePickerConfig: PropTypes.object,
    inputInfoConfig: PropTypes.shape({
        isInfoIcon: PropTypes.bool,
        iconName: PropTypes.string,
        message: PropTypes.string,
    }),
};

